<template>
  <div>
    <div
      class="md:shadow-card h-fit w-full space-y-2 rounded-lg bg-white px-6 py-8 md:p-14"
    >
      <div class="flex gap-2 md:gap-4">
        <Icon
          class="text-[2rem] text-primary md:text-[2.5rem]"
          name="celebration"
          is-filled
        />
        <h1 class="text-2xl font-medium text-zinc-800 md:text-4xl">
          {{ __('Onboarding complete!') }}
        </h1>
      </div>

      <p class="text-sm font-medium text-zinc-800 md:text-lg">
        {{
          __("Let's quickly review your professional profile. A complete and accurate profile ensures you see the very best opportunities.")
        }}
      </p>
    </div>
  </div>
</template>

<script setup>
  import { Icon } from '@/components/block/icon';
  import { useConfetti } from '@/utils/useConfetti';
  import {onMounted} from "vue";
  import {__} from "../../../../../helpers";

  onMounted(() => {
    const { launchConfetti } = useConfetti();
    setTimeout(() => {
      launchConfetti();
    }, 50);
  });
</script>
